export default __webpack_public_path__ + "static/rovo-dialect-diagram-dark-2d96cd9af4d6f8b3d5c4acde339119ef79a8a760e84f1e7b8a83694f8d41967a.png";